/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

export type ElectronicAccountTypeT =
  (typeof ElectronicAccountTypeT)[keyof typeof ElectronicAccountTypeT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ElectronicAccountTypeT = {
  businessChecking: "businessChecking",
  businessSavings: "businessSavings",
  personalChecking: "personalChecking",
  personalSavings: "personalSavings",
} as const;
